import React, { useEffect, useState } from "react";
import { Reveal } from "../../components/animations/reveal/reveal";

import Styles from "./annualReview.module.css";

import { Loader } from "../../components/loader/loader";
import { Error } from "../../components/error/error";

import {
    populateAnnualReviewData,
    saveAnnualReviewLocalSession,
    getAnnualReviewFromLocalSession
} from "../../utils";



export const AnnualReview = () => {

    const [displayItems, setDisplayItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAnnualReview = async () => {
        try {
            setIsLoading(true);
            let data = getAnnualReviewFromLocalSession();
            if (!data) {
                data = await populateAnnualReviewData();
                saveAnnualReviewLocalSession(data);
            }
            setDisplayItems(data);
        } catch (error) {
            setError({ message: "Uh oh, looks like something went wrong" });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAnnualReview();
    }, []);

    if (error) {
        return <Error error={error} id="annual-review-error" page="our-annual-review" />;
    }

    return (

        <>

            <div className={`${Styles.reviewContainer}`}>
                {
                    isLoading ? <Loader page="Our Annual Review" /> :
                        error ? <Error error={error} id="dashboard-error" page="our-annual-review" /> :
                        displayItems.map((AnnualReview, idx) => (
                           
                            <div className={Styles.reviewContent} key={idx}>
                                <Reveal>
                                    <div>
                                        {/*<iframe width="100%" height="490" src="https://www.youtube.com/embed/p9KJbTd2arc?si=Lq8rubNyaV36GzHy" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>*/}
                                        <iframe width="100%" height="490" src={`${AnnualReview.videoUrl}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>

                                    </div>
                                </Reveal>
                                <Reveal>
                                    <div className={Styles.reviewText}>
                                        <h1>{AnnualReview.title}</h1>
                                        <h3>{AnnualReview.subTitle}</h3>
                                        <p>{AnnualReview.subText1}</p>
                                        <p>{AnnualReview.subText2}</p>
                                        <p>{AnnualReview.subText3}</p>
                                    </div>
                                </Reveal>
                            </div>
                        ))

            }
            </div>
        </>
    )

    
}